// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".kt-notification .kt-notification__item[data-v-322da24e]:after{display:none}", "",{"version":3,"sources":["webpack://./resources/assets/js/partials/CurrentlyRecording.vue"],"names":[],"mappings":"AAAA,+DAAA,YAAA","sourcesContent":[".kt-notification .kt-notification__item:after{display:none}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
